<ng-container *ngIf="mcPreDraftDataPresent$ | async">
  <ps-ui-multi-country-pre-draft
    [multiCountryPreDraftData]="multiCountryPreDraftData"
    (multiCountryPreDraftDataUpdate)="onMultiCountryPreDraftDataUpdate($event)"
  ></ps-ui-multi-country-pre-draft>
</ng-container>

<ng-container *ngIf="mcSurveyDataPresent$ | async">
  <ps-ui-multi-country-draft
    [surveyDetails]="surveyDetails"
    [surveyPayload]="surveyPayload"
    [multiCountrySurveyData]="multiCountrySurveyData"
    [multiCountrySpvParentSurvey]="multiCountrySpvParentSurvey"
    [multiCountrySpvChildSurveys]="multiCountrySpvChildSurveys"
    [mcSvpPayload]="mcSvpPayload"
    [countries]="countries"
    (updateMultiCountrySurveyData)="onMultiCountrySurveyDataUpdate($event)"
    (updateMcSpvChildSurveysData)="onMcSpvSurveyDataUpdate($event)"
    [selectedTemplateId]="selectedTemplateId"
    (selectionChange)="selectionChange.emit($event)"
    (mcSurveyAdded)="onMcSurveyAdded($event)"
    (cancelTemplateSelection)="cancelTemplateSelection.emit($event)"
  ></ps-ui-multi-country-draft>
</ng-container>
